<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
  <form [formGroup]="serviceInfoForm" autocomplete="off">
    <div class="request-details">
      <mat-grid-list cols="4" rowHeight="76.5px" gutterSize="8px">
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <input matInput [matDatepicker]="datePicker" [min]="minDate" formControlName="date" placeholder="Date" (dateChange)="onServiceDateChange($event)" required>
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
            <mat-error *ngIf="serviceInfoForm.get('date').invalid && (serviceInfoForm.get('date').dirty || serviceInfoForm.get('date').touched)">
              Date is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field class="small-text">
            <input matInput type="time" formControlName="timeStart" placeholder="Start Time" (change)="onServiceTimeChange($event)" required>
            <mat-error *ngIf="serviceInfoForm.get('timeStart').invalid && (serviceInfoForm.get('timeStart').dirty || serviceInfoForm.get('timeStart').touched)">
              Start Time is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <div class="col-sm-12">
            <mat-checkbox formControlName="isProtocolRequired" (change)="onProtocolRequiredChange($event)">Airport Protocol</mat-checkbox>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="startAddress">
            <mat-form-field>
              <input matInput ngx-google-places-autocomplete formControlName="formattedAddress" (onAddressChange)="handleAddressChange($event,'startAddress')" placeholder="Pick Up Address" required>
              <mat-error *ngIf="serviceInfoForm.get('startAddress').invalid && (serviceInfoForm.get('startAddress').dirty || serviceInfoForm.get('startAddress').touched)">
                Pickup Address is required.
              </mat-error>
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="endAddress">
          <mat-form-field>
            <input matInput ngx-google-places-autocomplete formControlName="formattedAddress" (onAddressChange)="handleAddressChange($event,'endAddress')" placeholder="Drop Off Address" required>
            <mat-error *ngIf="serviceInfoForm.get('endAddress').invalid && (serviceInfoForm.get('endAddress').dirty || serviceInfoForm.get('endAddress').touched)">
              Drop Off Address is required.
            </mat-error>
          </mat-form-field>
        </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="startAddress">
          <mat-form-field>
            <input matInput formControlName="longitude" placeholder="Pick Up Longitude" required>
            <mat-error *ngIf="serviceInfoForm.get('startAddress').get('longitude').invalid && (serviceInfoForm.get('startAddress').get('longitude').dirty || serviceInfoForm.get('startAddress').get('longitude').touched)">
              Longitude is required.
            </mat-error>
          </mat-form-field>
        </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="startAddress">
          <mat-form-field>
            <input matInput formControlName="latitude" placeholder="Pick Up Latitude" required>
            <mat-error *ngIf="serviceInfoForm.get('startAddress').get('latitude').invalid && (serviceInfoForm.get('startAddress').get('latitude').dirty || serviceInfoForm.get('startAddress').get('latitude').touched)">
              Latitude is required.
            </mat-error>
          </mat-form-field>
        </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="endAddress">
          <mat-form-field>
            <input matInput formControlName="longitude" placeholder="Drop Off Longitude" required>
            <mat-error *ngIf="serviceInfoForm.get('endAddress').get('longitude').invalid && (serviceInfoForm.get('endAddress').get('longitude').dirty || serviceInfoForm.get('endAddress').get('longitude').touched)">
              Latitude is required.
            </mat-error>
          </mat-form-field>
        </div>
        </mat-grid-tile>

        <mat-grid-tile colspan="1">
          <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="endAddress">
          <mat-form-field>
            <input matInput formControlName="latitude" placeholder="Drop Off Latitude" required>
            <mat-error *ngIf="serviceInfoForm.get('endAddress').get('latitude').invalid && (serviceInfoForm.get('endAddress').get('latitude').dirty || serviceInfoForm.get('endAddress').get('latitude').touched)">
              Longitude is required.
            </mat-error>
          </mat-form-field>
        </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <br>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-select formControlName="detailsOfService" placeholder="Details of Service" required>
              <mat-option *ngFor="let serviceDetail of serviceDetailsArray" [value]="serviceDetail">
                {{serviceDetail}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="serviceInfoForm.get('detailsOfService').invalid && (serviceInfoForm.get('detailsOfService').dirty || serviceInfoForm.get('detailsOfService').touched)">
              Detail of Service required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field>
            <input matInput formControlName="specialRequests" placeholder="Special Request Notes">
            <mat-hint>(if required)</mat-hint>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <div class="row">
            <p>Required Resources: <mat-checkbox *ngFor="let role of resourceRoles" [disabled]="isCompletedOrActioned()" [checked]="isResourceRequested(role)"
              (change)="toggleResourceRequest(role)">{{role}}</mat-checkbox></p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-label>Required Resource Count</mat-label>
            <input matInput type="number" formControlName="requiredResourceCount" placeholder="0" min="0" max="100">
            <mat-hint>0 = not saved</mat-hint>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-label>Required Asset Count</mat-label>
            <input matInput type="number" formControlName="requiredAssetCount" placeholder="0" min="0" max="100">
            <mat-hint>0 = not saved</mat-hint>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="right-aligned-actions">
  <button mat-raised-button (click)="onCancel()" class="btn">Cancel</button>
  <button mat-raised-button (click)="onSubmit()" class="btn btn-primary">Save Changes</button>
</mat-dialog-actions>